import { render, staticRenderFns } from "./UserDashboardLeadsBox.vue?vue&type=template&id=1bd9818a&scoped=true&"
import script from "./UserDashboardLeadsBox.vue?vue&type=script&lang=js&"
export * from "./UserDashboardLeadsBox.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardLeadsBox.vue?vue&type=style&index=0&id=1bd9818a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9818a",
  null
  
)

export default component.exports